import { Box, Button } from "@mui/material";
import { Drawer } from "@zfp-akademie-a-s/zfp-design";
import type { CurrentContractBaseInvestmentToolType, CurrentContractBaseSolutionHorizonType } from "Infrastructure/ApiZfp/Schema";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { type FC, useRef, useState } from "react";
import { type CurrentSolutionFormHandle, CurrentSolutionWrapperForm } from "./Forms/CurrentSolution/CurrentSolutionWrapperForm";

type Props = {
  onClose: () => void;
  investmentToolType: CurrentContractBaseInvestmentToolType;
  solutionId?: string;
  horizonType: CurrentContractBaseSolutionHorizonType;
  readonly open: boolean;
};

export type SubmitCurrentSolutionFormHandle = {
  readonly submitForm: () => void;
  readonly deleteSolution?: () => void;
};

export const CurrentSolutionDrawer: FC<Props> = ({ onClose, investmentToolType, solutionId, horizonType, open }) => {
  const { t } = useResource();
  const currentSolutionFormRef = useRef<SubmitCurrentSolutionFormHandle & CurrentSolutionFormHandle>(null);
  const [contentReady, setContentReady] = useState(false);

  const isEdit = !!solutionId;

  const handleClose = () => {
    const active = document.activeElement as HTMLElement | null;
    if (active && typeof active.blur === "function") active.blur();
    onClose();
  };

  return (
    <Drawer
      open={open}
      onClose={handleClose}
      closeLabel={t(Resources.Common.Close)}
      title={
        isEdit ? t(Resources.AnalysisDetail.GoalsFulfillment.CurrentSolutionEdit) : t(Resources.AnalysisDetail.GoalsFulfillment.Current)
      }
      onEntered={() => setContentReady(true)}
      onExited={() => setContentReady(false)}
      startAction={
        isEdit && (
          <Button variant="text" onClick={() => currentSolutionFormRef.current?.deleteSolution?.()} color="error">
            {t(Resources.Common.Delete)}
          </Button>
        )
      }
      primaryAction={
        <Button variant="contained" type="submit" onClick={() => currentSolutionFormRef.current?.submitForm()}>
          {isEdit ? t(Resources.Common.Save) : t(Resources.Common.Create)}
        </Button>
      }
    >
      <Box mb={Spacing.XXL}>
        {contentReady && (
          <CurrentSolutionWrapperForm
            ref={currentSolutionFormRef}
            edit={isEdit}
            solutionID={solutionId}
            horizonType={horizonType}
            initialFormType={investmentToolType}
            onSuccess={onClose}
          />
        )}
      </Box>
    </Drawer>
  );
};
